import { useState } from 'react'
import { useHost } from '@10000/react'
import { SettingsLayout } from '../admin'
import { Table } from './tables/table'
import { industries, country as countries } from '../../lookups'
import { CustomHeader } from './tables/table'
import { Box, LoadMoreRows } from '../widgets'

export const Tenants = ({ setTenant }) => {
  const host = useHost()
  const [loadedInstances, setLoadedInstances] = useState([])
  const [search, setSearch] = useState('')

  const onSearch = newSearch => {
    setLoadedInstances([])
    setSearch(newSearch)
  }

  const getTenants = async (index, increment) => {
    const rows = await (search
      ? host.searchTenants(search, index, increment)
      : host.getTenantInstancesByIndex(index, increment)
    )
    setLoadedInstances(current => current.concat(rows))
  }

  const columns = [
    { key: 'name', name: 'Name', sortable: true, headerRenderer: CustomHeader },
    { key: 'country', name: 'Country', sortable: true, headerRenderer: CustomHeader },
    { key: 'city', name: 'City', headerRenderer: CustomHeader },
    { key: 'industry', name: 'Industry', sortable: true, headerRenderer: CustomHeader },
    { key: 'organisations', name: 'Organisations', sortable: true, headerRenderer: CustomHeader },
    { key: 'users', name: 'Users', sortable: true, headerRenderer: CustomHeader },
    { key: 'teams', name: 'Teams', sortable: true, headerRenderer: CustomHeader },
    { key: 'squizzes', name: 'Squizzes run', sortable: true, headerRenderer: CustomHeader }]

  const rows = loadedInstances.map(tenant => ({
    id: tenant?.id ? tenant.id : tenant.entityId,
    name: tenant.data?.company?.name || 'Not Found',
    country: countries?.name[tenant.data?.company?.country] || 'Not Found',
    city: tenant.data?.company?.city || 'Not Found',
    industry: industries[tenant.data?.company?.industry]?.name || 'Not Found',
    organisations: tenant.data?.organisations.length || 'N/A',
    teams: tenant.data?.teams.length || 0,
    users: tenant.data?.users.length || 0,
    squizzes: tenant.data?.squizzes.length || 0
  }))

  const onRowClicked = (_, row) => setTenant(row.id)

  return (
    <SettingsLayout
      gap={32}
      title="Tenants"
      fullWidth
      hideScrollBarGutters
      p={8}
    >
      <Box column fullWidth>
        <Table
          rows={rows}
          columns={columns}
          onRowClick={onRowClicked}
          defaultSortColumn="name"
          onSearch={onSearch}
        />
        <LoadMoreRows
          rows={loadedInstances}
          onLoadRows={getTenants}
          loadIncrement={10}
          key={search}
        />
      </Box>

    </SettingsLayout>
  )
}